import { useEffect, useState } from "react";

import { fetchPlayers, type Player } from "@/api/players";
import { cachedFetch } from "@/lib/requestCache";

type PlayersState = {
  readonly players: readonly Player[];
  readonly status: "loading" | "ready" | "error";
};

const CACHE_KEY = "sorteio-players";
const CACHE_TTL_MS = 30_000;

/**
 * Loads the ticket leaderboard, sorted by ticket count.
 * The shared cache keeps repeated mounts to a single network request.
 */
export function usePlayers(): PlayersState {
  const [state, setState] = useState<PlayersState>({ players: [], status: "loading" });

  useEffect(() => {
    let cancelled = false;

    cachedFetch(CACHE_KEY, CACHE_TTL_MS, () => fetchPlayers())
      .then((players) => {
        if (cancelled) return;
        setState({ players, status: "ready" });
      })
      .catch((error: unknown) => {
        if (cancelled) return;

        console.error("Failed to load ticket leaderboard", error);
        setState({ players: [], status: "error" });
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
